import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  PaginationEllipsis,
} from '@/components/ui/pagination';

interface CustomPaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  itemsPerPage?: number;
  showItemCount?: boolean;
}

export function CustomPagination({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  itemsPerPage = 20,
  showItemCount = true,
}: CustomPaginationProps) {
  const renderPaginationItems = () => {
    return Array.from({ length: totalPages }).map((_, index) => {
      const pageNumber = index + 1;

      if (pageNumber === 1 || pageNumber === totalPages || (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)) {
        return (
          <PaginationItem key={pageNumber}>
            <PaginationLink onClick={() => onPageChange(pageNumber)} isActive={currentPage === pageNumber}>
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        );
      }

      if (pageNumber === 2 && currentPage > 3) {
        return <PaginationEllipsis key='ellipsis-start' />;
      }

      if (pageNumber === totalPages - 1 && currentPage < totalPages - 2) {
        return <PaginationEllipsis key='ellipsis-end' />;
      }

      return null;
    });
  };

  return (
    <div className='mt-6 border-t pt-4 flex items-center justify-between'>
      {showItemCount && (
        <p className='text-sm text-muted-foreground'>
          Showing <span className='font-medium'>{totalItems > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0}</span> to{' '}
          <span className='font-medium'>{Math.min(currentPage * itemsPerPage, totalItems)}</span> of{' '}
          <span className='font-medium'>{totalItems}</span> items
        </p>
      )}

      <div className='flex-1 flex justify-center'>
        <Pagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
                className={currentPage === 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              />
            </PaginationItem>

            {renderPaginationItems()}

            <PaginationItem>
              <PaginationNext
                onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
                className={currentPage === totalPages ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>

      <div className='w-[180px]'></div>
    </div>
  );
}
